import { render, staticRenderFns } from "./CustomerCategories.vue?vue&type=template&id=41275732&scoped=true&"
import script from "./CustomerCategories.vue?vue&type=script&lang=js&"
export * from "./CustomerCategories.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCategories.vue?vue&type=style&index=0&id=41275732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41275732",
  null
  
)

export default component.exports